/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ConversationalAgentLanguageEnum } from './ConversationalAgentLanguageEnum';
import {
  ConversationalAgentLanguageEnumFromJSON,
  ConversationalAgentLanguageEnumFromJSONTyped,
  ConversationalAgentLanguageEnumToJSON,
} from './ConversationalAgentLanguageEnum';
import type { ConversationalAgentStateSchemaDetail } from './ConversationalAgentStateSchemaDetail';
import {
  ConversationalAgentStateSchemaDetailFromJSON,
  ConversationalAgentStateSchemaDetailFromJSONTyped,
  ConversationalAgentStateSchemaDetailToJSON,
} from './ConversationalAgentStateSchemaDetail';
import type { TaskTypeEnum } from './TaskTypeEnum';
import { TaskTypeEnumFromJSON, TaskTypeEnumFromJSONTyped, TaskTypeEnumToJSON } from './TaskTypeEnum';

/**
 *
 * @export
 * @interface DatasetPolymorphicVoiceAgentDataset
 */
export interface DatasetPolymorphicVoiceAgentDataset {
  /**
   *
   * @type {TaskTypeEnum}
   * @memberof DatasetPolymorphicVoiceAgentDataset
   */
  taskType: TaskTypeEnum;
  /**
   *
   * @type {number}
   * @memberof DatasetPolymorphicVoiceAgentDataset
   */
  readonly id: number;
  /**
   *
   * @type {string}
   * @memberof DatasetPolymorphicVoiceAgentDataset
   */
  datasetPath: string;
  /**
   *
   * @type {boolean}
   * @memberof DatasetPolymorphicVoiceAgentDataset
   */
  readonly hasPredictions: boolean;
  /**
   *
   * @type {ConversationalAgentStateSchemaDetail}
   * @memberof DatasetPolymorphicVoiceAgentDataset
   */
  readonly stateSchema: ConversationalAgentStateSchemaDetail;
  /**
   *
   * @type {boolean}
   * @memberof DatasetPolymorphicVoiceAgentDataset
   */
  evaluateState?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof DatasetPolymorphicVoiceAgentDataset
   */
  readonly hasState: boolean;
  /**
   *
   * @type {boolean}
   * @memberof DatasetPolymorphicVoiceAgentDataset
   */
  readonly hasTokenUsage: boolean;
  /**
   *
   * @type {ConversationalAgentLanguageEnum}
   * @memberof DatasetPolymorphicVoiceAgentDataset
   */
  language: ConversationalAgentLanguageEnum;
  /**
   *
   * @type {Array<number>}
   * @memberof DatasetPolymorphicVoiceAgentDataset
   */
  audioRecordings?: Array<number>;
}

/**
 * Check if a given object implements the DatasetPolymorphicVoiceAgentDataset interface.
 */
export function instanceOfDatasetPolymorphicVoiceAgentDataset(
  value: object,
): value is DatasetPolymorphicVoiceAgentDataset {
  if (!('taskType' in value) || value['taskType'] === undefined) return false;
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('datasetPath' in value) || value['datasetPath'] === undefined) return false;
  if (!('hasPredictions' in value) || value['hasPredictions'] === undefined) return false;
  if (!('stateSchema' in value) || value['stateSchema'] === undefined) return false;
  if (!('hasState' in value) || value['hasState'] === undefined) return false;
  if (!('hasTokenUsage' in value) || value['hasTokenUsage'] === undefined) return false;
  if (!('language' in value) || value['language'] === undefined) return false;
  return true;
}

export function DatasetPolymorphicVoiceAgentDatasetFromJSON(json: any): DatasetPolymorphicVoiceAgentDataset {
  return DatasetPolymorphicVoiceAgentDatasetFromJSONTyped(json, false);
}

export function DatasetPolymorphicVoiceAgentDatasetFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): DatasetPolymorphicVoiceAgentDataset {
  if (json == null) {
    return json;
  }
  return {
    taskType: TaskTypeEnumFromJSON(json['task_type']),
    id: json['id'],
    datasetPath: json['dataset_path'],
    hasPredictions: json['has_predictions'],
    stateSchema: ConversationalAgentStateSchemaDetailFromJSON(json['state_schema']),
    evaluateState: json['evaluate_state'] == null ? undefined : json['evaluate_state'],
    hasState: json['has_state'],
    hasTokenUsage: json['has_token_usage'],
    language: ConversationalAgentLanguageEnumFromJSON(json['language']),
    audioRecordings: json['audio_recordings'] == null ? undefined : json['audio_recordings'],
  };
}

export function DatasetPolymorphicVoiceAgentDatasetToJSON(
  value?: Omit<
    DatasetPolymorphicVoiceAgentDataset,
    'id' | 'hasPredictions' | 'stateSchema' | 'hasState' | 'hasTokenUsage'
  > | null,
): any {
  if (value == null) {
    return value;
  }
  return {
    task_type: TaskTypeEnumToJSON(value['taskType']),
    dataset_path: value['datasetPath'],
    evaluate_state: value['evaluateState'],
    language: ConversationalAgentLanguageEnumToJSON(value['language']),
    audio_recordings: value['audioRecordings'],
  };
}
